import { GUEST_VALIDATE_MPIN, GUEST_VALIDATE_MPIN_ERROR, GUEST_VALIDATE_MPIN_HIDE_ERROR, GUEST_VALIDATE_MPIN_START_LOADER, GUEST_VALIDATE_MPIN_STOP_LOADER, } from "../interface/iGuestValidateMPIN";
const initState = {
    data: {
        daysLeft: 0,
        status: false,
        userType: "",
        guestId: "",
        message: "",
        registeredDate: "",
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const guestValidateMPIN = (state = initState, action) => {
    switch (action.type) {
        case GUEST_VALIDATE_MPIN:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GUEST_VALIDATE_MPIN_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GUEST_VALIDATE_MPIN_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GUEST_VALIDATE_MPIN_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GUEST_VALIDATE_MPIN_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default guestValidateMPIN;
